import dayjs from 'dayjs'

export {
  PurchaseOrder,
  PurchaseOrderPatchRequest,
} from '@loadedhub/loaded-stock-api-sdk'
export type {
  IPurchaseOrder,
  IPurchaseOrderPatchRequest,
} from '@loadedhub/loaded-stock-api-sdk'

export interface WebApiPurchaseOrderLine {
  id?: string
  purchaseOrderId?: string
  stockItemId?: string
  stockItemName?: string
  brandId?: string
  brandName?: string
  unitId?: string
  unitName?: string
  unitRatio?: number
  quantity?: number
  unitCost?: number
  taxPercent?: number
  quantityOrdered?: number
  unitCostOrdered?: number
  stockCode?: string
  isValiated?: boolean
  stockCodeValid?: boolean
  quantityValid?: boolean
  masterSupplierItemName?: string
  masterSupplierItemPackSize?: number
  masterSupplierItemMinOrder?: number
}

export interface WebApiPurchaseOrder {
  id?: string
  supplierId?: string
  supplierName?: string
  supplierValidateStockCode?: boolean
  orderNumber?: number
  fullOrderNumber?: string
  datestampCreated?: dayjs.Dayjs
  datestampReceived?: dayjs.Dayjs
  datestampInvoiced?: dayjs.Dayjs
  datestampDeleted?: dayjs.Dayjs
  orderSent?: boolean
  received?: boolean
  clientPO?: string
  packingslipReference?: string
  invoiceNo?: string
  notes?: string
  subtotal?: number
  freight?: number
  freightTaxPercent?: number
  total?: number
  orderedBy?: string
  deletedById?: string
  stockOrderId?: string
  reconciled?: boolean
  deliveryInstructions?: string
  adviseIfFailed?: boolean
  failEmail?: string
  creditRequest?: boolean
  xeroInvoiceId?: string
  statementId?: string
  lines: WebApiPurchaseOrderLine[]
  commLogs?: string[]
  isValidated?: boolean
  stockCodeValid?: boolean
  quantityValid?: boolean
}

export const transformWebApiPurchaseOrderOnGet = (
  purchaseOrder: WebApiPurchaseOrder
): WebApiPurchaseOrder => {
  return {
    ...purchaseOrder,
    datestampCreated: purchaseOrder.datestampCreated
      ? dayjs(purchaseOrder.datestampCreated)
      : undefined,
    datestampReceived: purchaseOrder.datestampReceived
      ? dayjs(purchaseOrder.datestampReceived)
      : undefined,
    datestampInvoiced: purchaseOrder.datestampInvoiced
      ? dayjs(purchaseOrder.datestampInvoiced)
      : undefined,
    datestampDeleted: purchaseOrder.datestampDeleted
      ? dayjs(purchaseOrder.datestampInvoiced)
      : undefined,
  }
}
